import Vue from "vue";
import store from'../../store';
Vue.prototype.$commonParams=()=>{
    // console.log(123);
    store.commit("commonParamsChange");
    let common=store.state.common;
    // console.log(common.requestNo);
    return common;
}
